import { render, staticRenderFns } from "./CheckoutNotes.vue?vue&type=template&id=03ddc1e6&scoped=true"
import script from "./CheckoutNotes.vue?vue&type=script&lang=js"
export * from "./CheckoutNotes.vue?vue&type=script&lang=js"
import style0 from "./CheckoutNotes.vue?vue&type=style&index=0&id=03ddc1e6&prod&lang=scss&scoped=true"
import style1 from "./CheckoutNotes.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ddc1e6",
  null
  
)

export default component.exports